module.exports = __webpack_public_path__ + "img/northstar-9.2e2ee890.jpg";